import { type ListingPriceType } from '@/generated'

import { type PriceTypes } from './GetPriceLabelValue'

export const isKeyInListingPrice = (
  priceTypeKey: ListingPriceType,
  priceTypes: PriceTypes
): priceTypeKey is keyof PriceTypes => !!Object.keys(priceTypes).includes(priceTypeKey)
